import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ServisniPakety = {
	name: NAME,
	apiProvider,
	router,
};
